import { useStore } from '../store';
import { EndpointCard } from './EndpointCard';

export function EndpointDetailPanel() {
  const selectedEndpoint = useStore((state) => state.selectedEndpoint);
  const setSelectedEndpoint = useStore((state) => state.setSelectedEndpoint);

  if (!selectedEndpoint) return null;

  return (
    <aside className="endpoint-detail-panel">
      <div className="endpoint-detail-header">
        <h3>Endpoint Details</h3>
        <button 
          className="panel-close-btn" 
          onClick={() => setSelectedEndpoint(null)}
          title="Close panel (Esc)"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="endpoint-detail-content">
        <EndpointCard endpoint={selectedEndpoint} />
      </div>
    </aside>
  );
}
